import idb from "#/data-layer/idb";
import SPECIES from "#/model/SpeciesCodeList";
import * as scope from "#/utils/SpeciesScope";
import{ parse, serialize } from "cookie";

/**
 * General, global logout function to be used across the application.
 *
 * This function will handle the logout process, including clearing the IndexedDB
 * and redirecting the user to the identity provider's logout endpoint.
 *
 * @param {object} param
 * @param {object} param.auth - The authentication object from react-oidc-context.
 */
export async function logout({ auth }) {
  // Clear IDB before redirecting — signoutRedirect triggers page navigation,
  // which would abort the async clear if called after.
  await idb.clear();

  auth.signoutRedirect({
    id_token_hint: auth?.user?.id_token,
  });
}

const OPTIONS = {
  path: "/",
  maxAge: 60 * 60 * 24,
  sameSite: "strict",
  secure: location.protocol === "https:",
};

const getKey = () => {
  let authorizationCookie = null;
  if (scope.has(SPECIES.EQUINE.id)) {
    authorizationCookie = "authorizationHorses";
  }
  else if (scope.has(SPECIES.PIG.id)) {
    authorizationCookie = "authorizationPigs";
  }
  else if (scope.has(SPECIES.SHEEP.id) || scope.has(SPECIES.GOAT.id)) {
    authorizationCookie = "authorizationSmallLivestock";
  }
  return authorizationCookie;
}

export function setAuthIdCookie(id) {
  const key = getKey();
  if (key != null) {
    document.cookie = serialize(key, id, OPTIONS);
  }
}

export function getAuthIdFromCookie() {
  const key = getKey();
  if (key != null) {
    return parse(document.cookie)[key];
  }
}

export function clearAuthIdCookie() {
  const key = getKey();
  if (key != null) {
    document.cookie = serialize(key, "", { ...OPTIONS, maxAge: 0 });
  }
}
